// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.style-module_smallLabel_RH6485iPNrXdzvoAtNmh {
  font-family: "Open Sans", sans-serif;
  font-size: 0.7rem;
  color: #031c2d;
  font-weight: 600;
  display: inline-block;
  vertical-align: baseline;
  margin-top: 0.1rem;
  margin-bottom: 0.6rem;
}

.style-module_wrapper_PgA7F1E9hWrHue4AN4aQ {
  width: 100%;
}

.style-module_helperText_VXj9mbRW9L20EolfsMr4 {
  font-size: 0.75rem;
  color: var(--text-02);
  line-height: 1.5;
  z-index: 0;
  max-height: 3rem;
  margin-bottom: 0.5rem;
}`, "",{"version":3,"sources":["webpack://./src/components/Select/style.module.scss"],"names":[],"mappings":"AAAA;EACE,oCAAA;EACA,iBAAA;EACA,cAAA;EACA,gBAAA;EACA,qBAAA;EACA,wBAAA;EACA,kBAAA;EACA,qBAAA;AACF;;AAEA;EACE,WAAA;AACF;;AAEA;EACE,kBAAA;EACA,qBAAA;EACA,gBAAA;EACA,UAAA;EACA,gBAAA;EACA,qBAAA;AACF","sourcesContent":[".smallLabel {\n  font-family: \"Open Sans\",sans-serif;\n  font-size: 0.7rem;\n  color: #031c2d;\n  font-weight: 600;\n  display: inline-block;\n  vertical-align: baseline;\n  margin-top: .1rem;\n  margin-bottom: .6rem;\n}\n\n.wrapper {\n  width: 100%;\n}\n\n.helperText { \n  font-size: 0.75rem;\n  color: var(--text-02);\n  line-height: 1.5;\n  z-index: 0;\n  max-height: 3rem;\n  margin-bottom: 0.5rem;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"smallLabel": `style-module_smallLabel_RH6485iPNrXdzvoAtNmh`,
	"wrapper": `style-module_wrapper_PgA7F1E9hWrHue4AN4aQ`,
	"helperText": `style-module_helperText_VXj9mbRW9L20EolfsMr4`
};
export default ___CSS_LOADER_EXPORT___;
